import { AnimatePresence, motion } from "framer-motion";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import {ArrowUpward, RemoveCircleOutline, ThumbDown, ThumbUp, InfoOutlined, ThumbsUpDown, VisibilityOff} from "@material-ui/icons";
import React, {useRef, useState} from "react";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Tooltip} from "@material-ui/core";
import axios from "axios";
import apiUrl from "../../../shared/config";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {SuggestedIcon} from "../../Icons/Icons";
import {appearAndExit} from "../../../utils/commonAnimations";
import PresetModal from "../../UI/Modal/PresetModal/PresetModal";
import Auth from "../../../containers/Auth/Auth";
import {NavLink} from "react-router-dom";
import PersonRounded from '@material-ui/icons/PersonRounded';
import {useDispatch} from "react-redux";
import * as actionTypes from "../../../store/actions/actionTypes";



export default function SecondaryExampleGame({ game, index, shouldShowDelButton, gameSelected, handleDeleteAnyGame, token, userId, update, patternId, authors, permissions, upperGameId, allGames, getAssessment}) {
    const [editDesc, setEditDesc] = useState("");
    const [showButtons, setShowButtons] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false); // need this to stop tooltip when in popup
    const [isSuggestedOpen, setIsSuggestedOpen] = useState(false);
    const [isDelOpen, setIsDelOpen] = useState(false);
    const loginModal = useRef();
    const dispatch = useDispatch();


    const closeSuggestedPopover = () => {
        setIsSuggestedOpen(false);
    };

    const openUserProfile = (userId) => {
        closeSuggestedPopover();
        dispatch({type: actionTypes.SELECT_USER, userId: userId});
        dispatch({type: actionTypes.OPEN_USER_MODAL});
    }

    function handleUpgradeGame(pattern_desc, pattern_id, game_id) {
        const data = {
            pattern_id: +pattern_id,
            example_description: pattern_desc,
            game_id: game_id,
        };

        axios.post(apiUrl + "Pattern/setGame?token=" + token, data)
            .then(response => {
                console.log('Post successful:', response.data);
                setIsEditing(false);
                setEditDesc("");
                handleDeleteAnyGame(game.game_id, true, index);
                update();
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
    }

    function sendVote(vote) {
        if (token) {
            axios.get(apiUrl + "Vote/vote?vote=" + vote + "&token=" + token + "&primary_id=" + patternId + "&secondary_id=" + upperGameId + "&tertiary_id=" + game.game_id + '&vote_type=SECONDARY_GAME')
                .then(update).catch(() => console.log("Vote Failed"));
        } else {
            setIsPopoverOpen(false)
            loginModal.current.open()
        }
    }

    const carrotDest = () => {
        let total = -25;
        showButtons && (total -= 25);
        showButtons && canUpgrade(game.game_id) && shouldShowDelButton(game) && (total -= 25);
        shouldShowDelButton(game) && showButtons && (total -= 20);
        game && showButtons && (total -= 25);
        return total;
    };

    function canUpgrade(id) {
        return !allGames.some(item => item.game_id === id);
    }

    const assess = getAssessment(game.up_votes, game.down_votes);

    const deleteButton = <AnimatePresence>{shouldShowDelButton(game) && showButtons && (
        <motion.div
            key={`delete-button-${game.game_id}-${patternId}-${upperGameId}`}
            initial={{ opacity: 0, x: 15 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 15}}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        ><OverlayTrigger
            trigger="click"
            rootClose
            rootCloseEvent="click"
            placement='bottom'
            onToggle={() => setIsDelOpen(false)}
            show={isDelOpen}
            overlay={<Popover id='pattern-game-description'>
                <Popover.Content className="game-description">
                    Are you sure you want to delete this game?
                    <Button onClick={() => handleDeleteAnyGame(game.game_id, true, index)} size={"sm"} variant="primary" type="submit" className="delete-confirm-button">Delete</Button>
                </Popover.Content>
            </Popover>}
        >
            <Tooltip title={"Delete"} placement="top">
            <RemoveCircleOutline className="delete-icon" onClick={() => setIsDelOpen(prev=> !prev)}/>
            </Tooltip>
        </OverlayTrigger>
        </motion.div>
    )}</AnimatePresence>;

    const likeButton = showButtons && (<AnimatePresence>
        <Tooltip title="Agree" placement="top">
            <motion.div
                key={`like-button-${game.game_id}-${patternId}-${upperGameId}`}
                initial={{ opacity: 0, x: 15 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 15 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                style={{ display: 'inline-block' }}
            >
                <motion.div
                    key={`like-button-child-${game.game_id}-${patternId}-${upperGameId}`}
                    whileTap={{
                        scale: 1.2,
                        rotate: [0, -15, 0, 15, 0],
                        transition: { type: "spring", stiffness: 300, damping: 10, duration: 0.5 }
                    }}
                    style={{ fontWeight: "normal", color: "black", alignItems: "center" }}
                >
                    <ThumbUp
                        onClick={() => sendVote(game.user_vote === 1 ? 0 : 1)}
                        color={game.user_vote === 1 ? "inherit" : "action"}
                        style={{ width: '20px', height: '20px', marginRight: "4px" }}
                    />
                </motion.div>
            </motion.div>
        </Tooltip>
        </AnimatePresence>
    );

    const dislikeButton = showButtons && (<AnimatePresence>
        <Tooltip title="Disagree" placement="top">
            <motion.div
                key={`dislike-button-${game.game_id}-${patternId}-${upperGameId}`}
                initial={{ opacity: 0, x: 15 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 15 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                style={{ display: 'inline-block' }}
            >
                <motion.div
                    key={`dislike-button-child-${game.game_id}-${patternId}-${upperGameId}`}
                    whileTap={{
                        scale: 1.2,
                        rotate: [0, -15, 0, 15, 0],
                        transition: { type: "spring", stiffness: 300, damping: 10, duration: 0.5 }
                    }}
                    style={{ fontWeight: "normal", color: "black", alignItems: "center" }}
                >
                    <ThumbDown
                        onClick={() => sendVote(game.user_vote === -1 ? 0 : -1)}
                        color={game.user_vote === -1 ? "inherit" : "action"}
                        style={{ width: '20px', height: '20px', marginRight: "4px" }}
                    />
                </motion.div>
            </motion.div>
        </Tooltip>
        </AnimatePresence>
    );

    const carrotToExpand = (
        <motion.div
            key={`expand-carrot-${game.game_id}-${patternId}-${upperGameId}-horizontal`}
            animate={{
                x: carrotDest()
            }}
            style={{position: "absolute", display: "inline-flex"}} transition={{duration: 0.5, ease: "easeInOut"}}
        >
            {game.hidden_content
                ? <span style={{color: "#bf8888", fontWeight: "bold", alignItems: "center", display: "flex"}}>
                        Hidden Content
                    <OverlayTrigger
                        trigger={["hover", "focus"]}
                        rootClose
                        rootCloseEvent="click"
                        placement='bottom'
                        overlay={
                            <Popover id='hidden-content-info' style={{maxWidth: 1000}}>
                                <Popover.Title as="h3">Hidden Content</Popover.Title>
                                <Popover.Content className="hidden-content">
                                    {/*{"This secondary example game is hidden because the user who suggested it doesn't have a shared contact email. "}*/}
                                    {parseInt(userId) === parseInt(game.pattern_secondary_game_user_id)
                                        ? <>This secondary example game is hidden because you don't have a shared contact email. <br/><br/>Add and share a valid contact email to make this secondary example game visible to other users on the site. You can do this by
                                            editing your User Profile, entering a valid contact
                                            email, then click "Display Contact Email."</>
                                        : (authors && authors.some(author => author === parseInt(userId))) || permissions.edit_patterns
                                            ? <React.Fragment>{"This secondary example game is hidden because the user who suggested it doesn't have a shared contact email. \n\nTo make this secondary example game visible, users who "}
                                                {authors && authors.some(author => author === parseInt(userId)) ? "are pattern authors " : ""}
                                                {authors && authors.some(author => author === parseInt(userId)) && permissions.edit_patterns ? "or " : ""}
                                                {permissions.edit_patterns ? "have permission to edit patterns " : ""}
                                                {"can verify this game by liking it. \n\nFirst, make sure " +
                                                    "you have a valid contact email and check \"Display Contact Email\" " +
                                                    "in your User Profile. Then, like this game to verify it \n\n"}
                                                <i>This secondary game will remain verified until you remove your like
                                                    or unshare your contact email.</i>
                                            </React.Fragment>
                                            : ""}
                                </Popover.Content>
                            </Popover>
                        }
                    >
                        <VisibilityOff style={{transform: "scale(0.9)", marginLeft: 3}}/>
                    </OverlayTrigger>
                </span>
                : ''}
            <motion.div
                key={`expand-carrot-${game.game_id}-${patternId}-${upperGameId}-rotate`}
                animate={{
                    rotate: showButtons ? 90 : -90,
                }}
                onClick={() => setShowButtons(prev => !prev)}
                style={{display: "inline-flex"}} transition={{duration: 0.5, ease: "easeInOut"}}
            >
                <ExpandMoreIcon/>
            </motion.div>
        </motion.div>
    );

    const suggesterInfoButton = (
        <AnimatePresence>
            {game && showButtons && (
                    <motion.div
                        initial={{ opacity: 0, x: 15 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 15 }}
                        transition={{ duration: .5, ease: "easeInOut" }}
                    >
                        <OverlayTrigger
                            trigger="click"
                            rootClose
                            rootCloseEvent="click"
                            placement='bottom'
                            onToggle={() => setIsSuggestedOpen(false)}
                            show={isSuggestedOpen} // control the visibility using the state
                            overlay={
                                <Popover id='pattern-game-description'>
                                    <Popover.Content className="game-description">
                                        {`${game.is_author ? 'Submitted' : 'Suggested'} By:`}
                                        <span className={game.user_display_name ? "example-suggested-link" : ''} onClick={() => { openUserProfile(game.pattern_secondary_game_user_id); closeSuggestedPopover(); }}>
                                            {game.user_display_name && <PersonRounded style={{ marginTop: -3 }} />}
                                            {game.user_display_name || ' A Pattern Author'}
                                        </span>
                                    </Popover.Content>
                                </Popover>
                            }
                        >
                            <Tooltip title={!isSuggestedOpen ? `${game.is_author ? 'Submitted' : 'Suggested'} By` : ''}
                                     placement="top"
                                     onClick={() => setIsSuggestedOpen(prev => !prev)}>
                                <div style={{display: "flex"}}>
                                    <SuggestedIcon className="suggested-icon" />
                                </div>
                                </Tooltip>
                            </OverlayTrigger>
                    </motion.div>
            )}
        </AnimatePresence>
    );

    const ratingButton = <AnimatePresence>{showButtons && (
            <motion.div
                initial={{opacity: 0, x: 15}}
                animate={{opacity: 1, x: 0}}
                exit={{opacity: 0, x: 15}}
                transition={{duration: 0.5, ease: "easeInOut"}}
                style={{display: 'inline-block'}}
            >
                <OverlayTrigger
                    trigger="click"
                    rootClose
                    rootCloseEvent="click"
                    placement='bottom'
                    onToggle={() => setIsPopoverOpen(false)}
                    show={isPopoverOpen}
                    overlay={<Popover id='pattern-game-description'>
                        <Popover.Title>Rate This Example</Popover.Title>
                        <Popover.Content className="game-description">
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", minWidth: "200px"}}>
                                <p style={{ margin: 0, lineHeight: '1.5' }}>{"Total Votes: " + (game.up_votes + game.down_votes)}</p>
                                <div style={{gap: '5px', justifyContent: "normal"}}>
                                    {likeButton}
                                    {dislikeButton}
                                </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '10px' }}>
                                <span>Developer Assessment:</span>
                                <p style={{ color: assess.color, margin: 0 }}>{assess.assess}</p>
                            </div>
                        </Popover.Content>
                    </Popover>}>
                    <Tooltip title={"Rating"} placement="top">
                        <ThumbsUpDown className="rating-icon" onClick={() => setIsPopoverOpen(prev => !prev)}/>
                    </Tooltip>
                </OverlayTrigger>
            </motion.div>
    )} </AnimatePresence>;

    const upgrageGameButton = <AnimatePresence>{showButtons && shouldShowDelButton(game) && canUpgrade(game.game_id) && (<Tooltip title="Add Description" placement="top">
            <motion.div
                initial={{opacity: 0, x: 15}}
                animate={{opacity: 1, x: 0}}
                exit={{opacity: 0, x: 15}}
                transition={{duration: 0.5, ease: "easeInOut"}}
                style={{display: 'inline-block'}}
            >
                    <ArrowUpward onClick={() => { if(!isEditing) {
                        setIsEditing(true)} else {setEditDesc(""); setIsEditing(false)}}} className="upgrade-icon"/>
            </motion.div>
        </Tooltip>
    )} </AnimatePresence>;

    const upgradeGameWindow = <div className="secondary-popup"><Form
        className="secondary-form" style={{marginBottom: 0}}
        onSubmit={(event) => {
            event.preventDefault();
            handleUpgradeGame(editDesc, patternId, game.game_id);
        }}
    >
        <Form.Group controlId="editDescription">
            <Form.Control
                as="textarea"
                rows={3}
                value={editDesc}
                onChange={(e) => setEditDesc(e.target.value)}
                required
            />
        </Form.Group>
        <Button variant="secondary" onClick={() => {setIsEditing(false); setEditDesc("");}} style={{
            backgroundColor: 'red',
            borderColor: 'red',
            color: 'white',  // Adjust this color to match the picture color
            float: "right"
        }}>Cancel</Button>
        <Button variant="primary" type="submit" style={{
            float: 'right',
            marginRight: '10px',
        }}>Submit</Button>
    </Form></div>


    return (
        <>
        <motion.div>
        <motion.div
            className="secondary-mini-container"
            style={{ position: 'relative' }}
            key={`container-${game.game_id}-${patternId}-${upperGameId}`}
        >
            <motion.dt className="dl-title-secondary"  style={game.hidden_content ? {border: "3px solid #bf8888"} : {}}>
                <div className="game-title-container">
                    <div className="left-box">
                        {game.game_name + " "}
                    </div>
                    <motion.div className="right-box" style={game.hidden_content ? {minWidth: -1 * carrotDest() + 165} : {minWidth: -1 * carrotDest() + 20}}>
                        {carrotToExpand}
                        {/*{likeButton}*/}
                        {/*{dislikeButton}*/}
                        {deleteButton}
                        {upgrageGameButton}
                        {ratingButton}
                        {suggesterInfoButton}
                        <OverlayTrigger
                            trigger="click"
                            rootClose
                            rootCloseEvent="click"
                            placement='bottom'
                            overlay={
                                <Popover id='pattern-game-description'>
                                    <Popover.Title as="h3">Game Description — {game.game_name}</Popover.Title>
                                    <Popover.Content className="game-description">
                                        {game.game_description} —
                                        <NavLink
                                            to={'/PatternLibraryApp/GamesReference/' + game.game_id}
                                            exact
                                        >
                                            <span className="view-game-link" onClick={() => {
                                                //history.replace('/PatternLibraryApp/GamesReference');
                                                gameSelected(game.game_id);}}
                                            >
                                                View Game Details
                                            </span>
                                        </NavLink>
                                    </Popover.Content>
                                </Popover>
                            }
                        >
                            <Tooltip title="Info" placement="top">
                            <InfoOutlined className="new-info-icon"/>
                            </Tooltip>
                        </OverlayTrigger>
                    </motion.div>
                </div>
            </motion.dt>
        </motion.div>
            <AnimatePresence>{isEditing && <motion.div
                key="editPattern"
                variants={appearAndExit}
                initial="closed"
                animate="open"
                exit="closed"
            >{upgradeGameWindow}</motion.div>}</AnimatePresence>
        </motion.div>
        <PresetModal ref={loginModal} title={"Login to Rate Secondary Example Game"}><Auth shouldRedirect hideDragon/></PresetModal>
        </>
    );
}
